var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PaymentType',{attrs:{"payment-data":_vm.payment,"payment-due-date-visible":_vm.paymentDueDateVisible,"disabled":_vm.disabled},on:{"update":_vm.updateFormValue}})}
var staticRenderFns = []

export { render, staticRenderFns }